export const PRODUCT_SUBSTITUTIONS_OPTIONS = {
  YES: 1,
  NO: 2,
  ASK: 3,
};

export const getAdditionalReportFormatOptions = () => [
  {
    id: 'reportOptionsDeliverableDxfCB',
    key: 'reportOptionsDeliverableDxf',
    text: 'order_preferences__product_addons_DXF',
  },
  {
    id: 'reportOptionsDeliverableRxfCB',
    key: 'reportOptionsDeliverableRxf',
    text: 'order_preferences__product_addons_RXF',
  },
  {
    id: 'reportOptionsDeliverableXmlCB',
    key: 'reportOptionsDeliverableXml',
    text: 'order_preferences__product_addons_XML',
  },
];
